<div class="h-dvh flex flex-col fade-slide-in">
  <app-filters-sidebar/>
  <div [class.lg:ml-64]="resultTableService.isSidebarOpen()" class="p-4 lg:pb-36 pb-12 flex flex-col flex-1 min-h-0 transition-[margin] duration-300">
    <app-results-header/>
    <app-results-table/>
  </div>
</div>

<app-results-footer/>
